<template>
  <div class="content-wrapper">
    <ContentHeader title="Добро пожаловать в личный кабинет" />
    <div class="content-body">
      <div class="row">
        <BalanceCard header="Карты лояльности" subHeader="Бонусы и скидки" iconClass="icon-credit-card2"
          path="/discount"
          v-if="(isDiscountCardsEnabled || isBonusesEnabled) && discountCardToDisplay">
          <ul class="list-group list-group-flush">
            <BalanceCardRow v-if="isDiscountBonusInfoLoading" title="Загрузка..." :value="null" />
            <template v-else>
              <BalanceCardRow v-if="isBonusesEnabled" title="Бонусы" :value="discountCardBonusBalance" />
              <button v-if="discountCardToDisplay" class="list-group-item"
                @click="qrcodeValue = discountCardToDisplay; qrcodeShow = true" style="width:100%;cursor:pointer;">Показать QR-код
                карты</button>
            </template>
          </ul>
        </BalanceCard>
        <BalanceCard header="Топливные карты" subHeader="Денежный остаток" iconClass="icon-banknote" path="/cards"
          :balances="moneyBalances" :loading="isCardsBalanceLoading" />
        <BalanceCard header="Топливные карты" subHeader="Остаток в литрах" iconClass="icon-speedometer" path="/cards"
          :balances="fuelBalances" :loading="isCardsBalanceLoading" />
        <BalanceCard header="Топливные талоны" subHeader="Остаток в литрах" iconClass="icon-barcode" path="/tickets"
          :balances="ticketBalances" :loading="isTicketsLoading" />
      </div>
      <RecentTable header="Недавние заявки" :subHeader="`Всего заявок - ${this.getRequestsCount}`" linkPath="requests"
        linkTitle="Все заявки" :fields="requestFields" :items="getRequests" :busy="isRequestsLoading"
        :failed="isRequestsFailed" />
      <qrcodeModal v-if="qrcodeShow" :value="qrcodeValue" @close="qrcodeShow = false" />
    </div>
  </div>
</template>

<script>
import ContentHeader from "@/components/ContentHeader.vue";
import BalanceCard from "@/components/BalanceCard.vue";
import BalanceCardRow from "@/components/BalanceCardRow.vue";
import RecentTable from "@/components/RecentTable.vue";
import qrcodeModal from '@/components/qrcodeModal.vue';
import { requestFields } from "@/fields.js";
import { mapGetters } from "vuex";
import { REQUESTS_REQUEST } from "@/store/actions/requests";
import { CARDS_BALANCE_REQUEST } from "@/store/actions/cards";
import { TICKETS_REQUEST } from "@/store/actions/tickets";
import { DISCOUNT_BONUS_INFO_REQUEST } from "@/store/actions/discount";

export default {
  name: "Main",
  components: {
    ContentHeader,
    BalanceCard,
    BalanceCardRow,
    RecentTable,
    qrcodeModal,
  },
  data() {
    return {
      requestFields,
      qrcodeShow: false,
      qrcodeValue: null,
    };
  },
  computed: {
    ...mapGetters([
      "getRequests",
      "getRequestsCount",
      "isRequestsLoading",
      "isRequestsFailed",
      "requestsOnceLoaded",

      "getMoneyBalance",
      "getFuelBalances",
      "isCardsBalanceLoading",
      "isCardsBalanceFailed",
      "cardsBalancesOnceLoaded",

      "getTickets",
      "getTicketsBalances",
      "isTicketsLoading",
      "isTicketsFailed",
      "ticketsOnceLoaded",
      "ticketsOnceLoaded",

      "getDiscountBonusInfo",
      "isDiscountBonusInfoLoading",
      "isDiscountBonusInfoFailed",
      "discountBonusInfoOnceLoaded",

      "isDiscountCardsEnabled",
      "isBonusesEnabled",
    ]),
    fuelBalances() {
      let balances = [];
      this.getFuelBalances.forEach((f) => {
        balances.push({ title: f.name, value: f.quantity });
      });
      return balances;
    },
    moneyBalances() {
      return this.isCardsBalanceLoading
        ? []
        : [{ title: "Тенге", value: this.getMoneyBalance }];
    },
    ticketBalances() {
      let balances = [];
      this.getTicketsBalances.forEach((t) => {
        balances.push({ title: t.product_name, value: t.active_quantity });
      });
      return balances;
    },
    discountCardBonusBalance() {
      return this.getDiscountBonusInfo?.balance ?? 0;
    },
    discountCardToDisplay() {
      return String(this.getDiscountBonusInfo?.card_to_display ?? "");
    },
  },
  created() {
    if (!this.requestsOnceLoaded) this.$store.dispatch(REQUESTS_REQUEST);
    if (!this.cardsBalancesOnceLoaded)
      this.$store.dispatch(CARDS_BALANCE_REQUEST);
    if (!this.ticketsOnceLoaded) this.$store.dispatch(TICKETS_REQUEST);
    if (!this.discountBonusInfoOnceLoaded) this.$store.dispatch(DISCOUNT_BONUS_INFO_REQUEST);
  },
};
</script>